import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import ToggleBoxField from '../../../components/inputs/toggleBoxField'
import LoaderButton from '../../../components/loaderButton'
import { optInProductPackage } from '../productPackageActions'
import {
  selectCurrentRefiVehicle,
  selectCurrentRefiUser,
} from '../../../reducers'
import { coverageDetailsNextStep } from '../refiActions'

export const MembershipSection = ({
  vehicle,
  user,
  optInProductPackage,
  coverageDetailsNextStep,
}) => {
  const [isMembershipAccepted, setIsMembershipAccepted] = useState(true)

  const handleSubmit = (e) => {
    e?.preventDefault()
    if (isMembershipAccepted)
      optInProductPackage({ vehicle_id: vehicle.id, user_id: user.id })

    coverageDetailsNextStep()
  }

  // hack for MVP: immediately skip
  useEffect(() => {
    coverageDetailsNextStep()
  }, [])
  if (true) {
    return null
  }

  return (
    <form>
      <div className="flex-align-vert-center">
        <div className="coverage__sub-header">
          Free 60-Day membership in Drive America
        </div>
      </div>
      <div>
        <ToggleBoxField
          name="drive-america-free-membership"
          options={[
            {
              label: 'Yes, accept',
              value: 'membership-yes',
              checked: isMembershipAccepted,
            },
            {
              label: 'No thanks',
              value: 'membership-no',
              checked: !isMembershipAccepted,
            },
          ]}
          onChange={(value) =>
            setIsMembershipAccepted(value === 'membership-yes')
          }
        />
      </div>

      <LoaderButton
        className="button button-drive-america"
        data-testid="membership-button"
        type="submit"
        onClick={handleSubmit}
      >
        Next
      </LoaderButton>
    </form>
  )
}

export const mapStateToProps = (state) => ({
  vehicle: selectCurrentRefiVehicle(state),
  user: selectCurrentRefiUser(state),
})

export default connect(mapStateToProps, {
  optInProductPackage,
  coverageDetailsNextStep,
})(MembershipSection)
